import fetch from '../../../../utils/fetch'
import {urlBuilder} from "../../../../helpers/url_builder_helper";

const initialState = {
  isLoading: false,
  error: null,
  datasheets: null,
  allDatasheets: null,
}

const getters = {
  allDatasheets(state) {
    return state.allDatasheets
  },
  sortedDatasheets(state) {
    if (state.allDatasheets) {
      return state.allDatasheets
        .filter(ds => ds.name && ds.name.trim() !== '')
        .map(ds => ({
          ...ds,
          displayName: ds.name + (ds.published ? ' (published)' : ' (draft)')
        }))
        .sort((a, b) => {
        if (a.published !== b.published) {
          if (a.published > b.published) {
            return -1
          } else {
            return 1
          }
        }
        let ad = a.name.toLowerCase(),
          bd = b.name.toLowerCase();
        if (ad < bd) return -1;
        if (ad > bd) return 1;
        return 0;
      });
    } else {
      return []
    }
  },
  datasheets(state) {
    return state.datasheets
  },
  publishedDatasheets(state) {
    if (state.allDatasheets === null) {
      return []
    }
    return state.allDatasheets.filter((datasheet) => {
      return datasheet.published && datasheet.name
    }).sort((a, b) => {
      let ad = a.name.toLowerCase(),
        bd = b.name.toLowerCase();
      if (ad < bd) return -1;
      if (ad > bd) return 1;
      return 0;
    });
  },
  isLoading(state) {
    return state.isLoading
  },
  error(state) {
    return state.error
  },
}

const actions = {
  get({commit, rootGetters}, data) {
    commit(types.SET_PROJECT_DATASHEETS_LOADING);
    return fetch('/projects/' + rootGetters['project/get/id'] + '/datasheets' + data.urlParams)
      .then(response => response.json())
      .then((data) => {
        commit(types.SET_PROJECT_DATASHEETS, data)
        return data
      })
      .catch((error) => {
        commit(types.SET_PROJECT_DATASHEETS_ERROR, error.message)
      })
  },

  getAll({commit}, projectId) {
    commit(types.RESET_ALL)
    commit(types.SET_PROJECT_DATASHEETS_LOADING);
    const maxFetch = 500;
    const ctx = {currentPage: 1, perPage: maxFetch, sortDesc: false, sortBy: 'name'};
    let url = '/projects/' + projectId + '/datasheets';
    return fetch(url + `${urlBuilder(ctx)}`)
      .then(response => response.json())
      .then((data) => {
        commit(types.ADD_DS, data['hydra:member'])
        commit(types.STOP_LOADING)
      })
      .catch((e) => {
        commit(types.GET_ALL_DS_ERROR, e.message)
      })
  },
}

const types = {
  SET_PROJECT_DATASHEETS_LOADING: 'SET_PROJECT_DATASHEETS_LOADING',
  SET_PROJECT_DATASHEETS: 'SET_PROJECT_DATASHEETS',
  SET_PROJECT_DATASHEETS_ERROR: 'SET_PROJECT_DATASHEETS_ERROR',
  RESET_ERROR: 'RESET_ERROR',
  RESET: 'RESET',


  STOP_LOADING: 'STOP_LOADING',
  ADD_DS: 'ADD_DS',
  GET_ALL_DS_ERROR: 'GET_ALL_DS_ERROR',
  RESET_ALL: 'RESET_ALL',
}

const mutations = {
  [types.SET_PROJECT_DATASHEETS_LOADING](state) {
    state.isLoading = true;
    state.error = false;
  },
  [types.SET_PROJECT_DATASHEETS](state, datasheets) {
    state.datasheets = datasheets
    state.isLoading = false;
  },
  [types.SET_PROJECT_DATASHEETS_ERROR](state, error) {
    state.error = error;
    state.isLoading = false;
  },
  [types.RESET_ERROR](state) {
    state.isLoading = false;
    state.error = false;
  },
  [types.RESET](state) {
    state = initialState
  },

  [types.STOP_LOADING](state) {
    state.isLoading = false;
  },
  [types.ADD_DS](state, allDatasheets) {
    state.allDatasheets = allDatasheets;
  },
  [types.GET_ALL_DS_ERROR](state, error) {
    state.error = error;
    state.isLoading = false;
  },
  [types.RESET_ALL](state) {
    state.allDatasheets = initialState.allDatasheets
  },
}

export default {
  namespaced: true,
  state: initialState,
  getters: getters,
  actions: actions,
  mutations: mutations
}
